import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Grid,
  Header,
  Form as FormUi,
  Icon,
  Divider
} from "semantic-ui-react";
import {billingPartyBranchConst, buttons} from './billingPartyConstants'

const BranchDetailsModal = ({
  data
}) => {
  const [modalOpen, setmodalOpen] = useState(false);

  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        trigger={
          <Button
            type="button"
            add_mode="edit"
            onClick={handleOpen}
            size="mini"
            basic
            icon
          >
            <Icon name="eye" />
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          {billingPartyBranchConst?.table_title||"Branch Details"}
        </Modal.Header>
        <Modal.Content scrolling style={{ height: "18em" }}>
          <Modal.Description style={{ height: "10em" }}>
            <Grid columns={4} className="ml-2">
              <Grid.Row>
              <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.branch_code||"Branch Code"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.billingPartyBranchCode ? data.billingPartyBranchCode : "NA"}
                  </Header>
                </Grid.Column>

                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName "
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.branch_name||"Branch"}
                  </Header>
                </Grid.Column>

                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    color="black"
                    as="label"
                    >
                    <div className="fixedLength150">
                      <p>{data?.billingPartyBranchName ? data.billingPartyBranchName : "NA"}</p>
                    </div>
                  </Header>
                </Grid.Column>
                
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.city||"City"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.cityName ? data.cityName : "NA"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.pincode||"Pincode"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.billingPartyBranchPincode ? data.billingPartyBranchPincode : "NA"}
                  </Header>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.pan_number||"Pan Number"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.billingPartyBranchPan ? data.billingPartyBranchPan : "NA"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.contact_person||"Contact Person"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    color="black"
                    as="label"
                  >
                     <div className="fixedLength150">
                      <p>{data?.contactPersonName ? data.contactPersonName : "NA"}</p>
                    </div>
                    
                  </Header>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.mobile||"Mobile Number"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.mobileNo ? data.mobileNo : "NA"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                   {billingPartyBranchConst?.detail_headers?.landline||"Landline Number"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.landLineNo ? data.landLineNo : "NA"}
                  </Header>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
              <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.state||"State"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.state ? data.state : "NA"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.address||"Address"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    color="black"
                    as="label"
                  >
                     <div className="fixedLength150">
                      <p>{data?.billingPartyBranchAddress ? data.billingPartyBranchAddress : "NA"}</p>
                    </div>
                    
                  </Header>
                </Grid.Column>
              </Grid.Row>
              <Divider horizontal>
                <Header as='h4'>
                {billingPartyBranchConst?.gst_title||"GST Details" }
                </Header>
              </Divider>

              <Grid.Row>
              <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.is_gst_applicable||"Is GST Applicable?"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.isGstApplicable && data.isGstApplicable===1 ? "YES" : "NO"}
                  </Header>
                </Grid.Column>

                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.gst_no||"GST Number"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.billingPartyBranchGst ? data.billingPartyBranchGst : "NA"}
                  </Header>
                </Grid.Column>
                </Grid.Row>
                
                <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.is_gst_exempted||"Is GST Exempted?"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.isGSTExempted && data?.isGstApplicable===1 && data.isGSTExempted===1  ? "YES" : "NO"}
                  </Header>
                </Grid.Column>

                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.exempted_reason||"GST Exempted Reason"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.GSTExemptedReasonName ? data.GSTExemptedReasonName : "NA"}
                  </Header>
                </Grid.Column>
              </Grid.Row>

              <Divider horizontal>
                <Header as='h4'>
                {billingPartyBranchConst?.bank_title||"Bank Details" }
                </Header>
              </Divider>

              <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                   {billingPartyBranchConst?.detail_headers?.bank_name||"Bank Name"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    color="black"
                    as="label"
                  >
                     <div className="fixedLength150">
                      <p>{data?.billingPartyBranchBankName ? data.billingPartyBranchBankName : "NA"}</p>
                    </div>
                   
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.account_holder||"Acount Holder Name"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                     <div className="fixedLength150">
                      <p>{data?.billingPartyBranchBankAccountHolder ? data.billingPartyBranchBankAccountHolder : "NA"}</p>
                    </div>
                    
                  </Header>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                   {billingPartyBranchConst?.detail_headers?.account_no||"Acount Number"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.billingPartyBranchAccountNumber ? data.billingPartyBranchAccountNumber : "NA"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {billingPartyBranchConst?.detail_headers?.ifsc||"IFSC Code"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.billingPartyBranchBankIFSC ? data.billingPartyBranchBankIFSC : "NA"}
                  </Header>
                </Grid.Column>
              </Grid.Row>

            </Grid>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
          type="button"
            onClick={handleClose}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {buttons.ok||"Ok"}
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default BranchDetailsModal;
